// get and post api functions will be here
import { access_token } from "./config";
import { get_access_token } from "./auth";

function get_auth_data(url) {
  return fetch(url, {
    method: "get",
    headers: new Headers({
      "app-client": "pdApp",
      "Content-Type": "application/json",
      "access-token": get_access_token(),
    }),
  }).then(function (res) {
    if (res.status === 500)
      return Promise.reject({
        status: false,
        message: "Server is not responding, please try again !",
      });

    return res.json();
  });
}

function get_excel_data(url) {
  return fetch(url, {
    method: "get",
    headers: new Headers({
      "app-client": "pdApp",
      "Content-Type": "application/vnd.ms-excel",
      "access-token": get_access_token(),
    }),
    responseType: "arraybuffer",
  }).then(function (res) {
    if (res.status === 500)
      return Promise.reject({
        status: false,
        message: "Server is not responding, please try again !",
      });

    return res.blob();
  });
}

function get_data(url) {
  return fetch(url, {
    method: "get",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
  }).then(function (res) {
    if (res.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    } else if (res.status === 500) {
      return Promise.reject({
        success: false,
        message: "Server is not responding, please try again !",
      });
    }

    return res.json();
  });
}

function get_data_public(url) {
  return fetch(url, {
    method: "get",
    headers: new Headers({
      // "app-client": "pdApp" ,

      "Content-Type": "application/json",
      access_token: get_access_token(),
    }),
  }).then(function (res) {
    if (res.status === 500)
      return Promise.reject({
        status: false,
        message: "Server is not responding, please try again !",
      });

    return res.json();
  });
}

function post_data(url, data, customHeaders = {}) {
  const defaultHeaders = {
    "Content-Type": "application/json",
  };

  const headers = new Headers({
    ...defaultHeaders,
    ...customHeaders,
  });

  return fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify(data),
  }).then(function (res) {
    if (res.status === 500)
      return Promise.reject("Server is not responding, please try again !");

    return res.json();
  });
}

function post_data_redeem(url, data, customHeaders = {}) {
  const defaultHeaders = {
    "Content-Type": "application/json",
    access_token: localStorage.getItem("token"),
  };

  const headers = new Headers({
    ...defaultHeaders,
    ...customHeaders,
  });

  return fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify(data),
  }).then(function (res) {
    if (res.status === 500)
      return Promise.reject("Server is not responding, please try again !");

    return res.json();
  });
}
function post_image(url, data) {
  return fetch(url, {
    method: "post",
    headers: new Headers({
      "app-client": "pdApp",
      "access-token": get_access_token(),
    }),
    body: data,
  }).then(function (res) {
    if (res.status === 500)
      return Promise.reject({
        status: false,
        message: "Server is not responding, please try again !",
      });

    return res.json();
  });
}

function put_data(url, data) {
  return fetch(url, {
    method: "put",
    headers: new Headers({
      // "app-client": "pdApp",
      "Content-Type": "application/json",
      // "access-token": get_access_token(),
    }),
    body: JSON.stringify(data),
  }).then(function (res) {
    if (res.status === 500)
      return Promise.reject({
        status: false,
        message: "Server is not responding, please try again !",
      });

    return res.json();
  });
}

function put_data_public(url, data) {
  return fetch(url, {
    method: "put",
    headers: new Headers({
      // "app-client": "pdApp" ,
      "Content-Type": "application/json",
      access_token: localStorage.getItem("token"),
    }),
    body: JSON.stringify(data),
  }).then(function (res) {
    if (res.status === 500)
      return Promise.reject({
        status: false,
        message: "Server is not responding, please try again !",
      });

    return res.json();
  });
}

function delete_data(url, data) {
  return fetch(url, {
    method: "delete",
    headers: new Headers({
      "app-client": "pdApp",
      "Content-Type": "application/json",
      "access-token": get_access_token(),
    }),
    body: JSON.stringify(data),
  }).then(function (res) {
    if (res.status === 500)
      return Promise.reject({
        status: false,
        message: "Server is not responding, please try again !",
      });

    return res.json();
  });
}

export {
  get_data,
  post_data,
  put_data,
  get_auth_data,
  delete_data,
  post_image,
  get_excel_data,
  get_data_public,
  put_data_public,
  post_data_redeem,
};
